import { ListModel, model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { SkillLevelQuestionnaireAnswerModel } from './SkillLevelQuestionnaireAnswerModel';
import { schemas } from '@api';

export class SkillLevelQuestionnaireAnswerList extends ListModel(
  types.reference(SkillLevelQuestionnaireAnswerModel),
  {
    idAttribute: 'id',
    schema: schemas.SkillLevelQuestionnaireAnswerListSchema,
  },
) {}

export const SkillLevelQuestionnaireAnswerListModel = model(
  SkillLevelQuestionnaireAnswerList,
);
